import type { IServiceOrganizationSettings as IServicesByServiceGroupForEpisodeCategory } from '@common/interfaces/';
import type { IServiceOrganizationSettings } from '@frontend/components/interfaces/serviceOrganizationSettings';

export enum ServiceOrganizationSettingFormMode {
    edit = 'edit',
    read = 'read',
}

export interface IServiceOrganizationSettingEditOrReadFormSectionProps extends IServiceOrganizationSettings {
    mode: ServiceOrganizationSettingFormMode;
}

export interface IServiceOrganizationSettingAddCarePathFormSectionProps
    extends IServicesByServiceGroupForEpisodeCategory {
    mode: ServiceOrganizationSettingFormMode.edit;
}

export type IServiceOrganizationSettingFormSectionProps =
    | IServiceOrganizationSettingEditOrReadFormSectionProps
    | IServiceOrganizationSettingAddCarePathFormSectionProps;
